(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    

class LRStickyHeader extends HTMLElement {

  connectedCallback() {

    this.wrapper = document.querySelector('.section-header');

    if (!this.wrapper) return;

    this.stickyType = this.getAttribute('data-sticky-type') || 'none';
    this.lastScroll = Math.max(window.scrollY, 0);
    this.rafPending = false;

    this.updateHeight();
    this.configureStickyMode();
    this.bindDrawerState();

    window.addEventListener('resize', () => {
      this.updateHeight();
    });

    window.addEventListener(
      'scroll',
      () => this.queueScrollUpdate(),
      { passive: true }
    );
  }


  updateHeight() {

    const inner = this.querySelector('.lr-header__inner');

    const height = inner
      ? inner.getBoundingClientRect().height
      : this.getBoundingClientRect().height;

    document.documentElement.style.setProperty(
      '--lr-header-height',
      Math.round(height) + 'px'
    );
  }


  configureStickyMode() {

    if (this.stickyType === 'none') {
      this.wrapper.classList.remove(
        'lr-sticky-enabled',
        'lr-header-hidden'
      );
      return;
    }

    this.wrapper.classList.add('lr-sticky-enabled');

    if (
      this.stickyType === 'always' ||
      this.stickyType === 'reduce-logo-size'
    ) {
      this.wrapper.classList.remove('lr-header-hidden');
    }
  }


  queueScrollUpdate() {

    if (this.rafPending) return;

    this.rafPending = true;

    requestAnimationFrame(() => {
      this.handleScroll();
      this.rafPending = false;
    });
  }


  handleScroll() {

    const current = Math.max(window.scrollY, 0);

    if (this.stickyType !== 'on-scroll-up') {
      this.lastScroll = current;
      return;
    }

    if (this.wrapper.classList.contains('lr-drawer-open')) {
      this.wrapper.classList.remove('lr-header-hidden');
      this.lastScroll = current;
      return;
    }

    const delta = current - this.lastScroll;

    /* Ignore tiny touch/trackpad jitter only. */
    if (Math.abs(delta) < 2) {
      return;
    }

    if (current <= 4) {
      this.wrapper.classList.remove('lr-header-hidden');
      this.lastScroll = current;
      return;
    }

    /* Scroll down = hide. */
    if (delta > 0) {
      this.wrapper.classList.add('lr-header-hidden');
    }

    /* Scroll up = show immediately. */
    if (delta < 0) {
      this.wrapper.classList.remove('lr-header-hidden');
    }

    this.lastScroll = current;
  }


  bindDrawerState() {

    const details = this.querySelector('.lr-header__mobile-nav details');

    if (!details) return;

    const sync = () => {
      const open = details.hasAttribute('open');

      this.wrapper.classList.toggle('lr-drawer-open', open);

      if (open) {
        this.wrapper.classList.remove('lr-header-hidden');
        this.updateHeight();
      }
    };

    details.addEventListener('toggle', sync);
    sync();
  }
}


if (!customElements.get('lr-sticky-header')) {

  customElements.define(
    'lr-sticky-header',
    LRStickyHeader
  );

}


  } catch(e) { console.error(e); }
})();
})();
